/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateProductionOrderFromRoutingRequest } from '../models/CreateProductionOrderFromRoutingRequest';
import type { ProductionExecutionDto } from '../models/ProductionExecutionDto';
import type { ProductionOperationDto } from '../models/ProductionOperationDto';
import type { ProductionOperationRelationshipDto } from '../models/ProductionOperationRelationshipDto';
import type { ProductionOrderDto } from '../models/ProductionOrderDto';
import type { ProductionScheduleDto } from '../models/ProductionScheduleDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ProductionOrderControllerService {
    /**
     * @param uuid
     * @returns ProductionOrderDto OK
     * @throws ApiError
     */
    public static findByUuid(
        uuid: string,
    ): CancelablePromise<ProductionOrderDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/production-orders/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @param requestBody
     * @returns ProductionOrderDto OK
     * @throws ApiError
     */
    public static update(
        uuid: string,
        requestBody: ProductionOrderDto,
    ): CancelablePromise<ProductionOrderDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/production-orders/{uuid}',
            path: {
                'uuid': uuid,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param uuid
     * @returns any OK
     * @throws ApiError
     */
    public static delete(
        uuid: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/production-orders/{uuid}',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @returns ProductionOrderDto OK
     * @throws ApiError
     */
    public static findAll(): CancelablePromise<Array<ProductionOrderDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/production-orders',
        });
    }
    /**
     * @param requestBody
     * @returns ProductionOrderDto OK
     * @throws ApiError
     */
    public static create(
        requestBody: ProductionOrderDto,
    ): CancelablePromise<ProductionOrderDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/production-orders',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param requestBody
     * @returns ProductionOrderDto OK
     * @throws ApiError
     */
    public static createFromRouting(
        requestBody: CreateProductionOrderFromRoutingRequest,
    ): CancelablePromise<ProductionOrderDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/production-orders/create-from-routing',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
    /**
     * @param uuid
     * @returns ProductionScheduleDto OK
     * @throws ApiError
     */
    public static getProductionSchedules(
        uuid: string,
    ): CancelablePromise<Array<ProductionScheduleDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/production-orders/{uuid}/schedules',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @returns ProductionOperationRelationshipDto OK
     * @throws ApiError
     */
    public static getProductionOperationRelationships(
        uuid: string,
    ): CancelablePromise<Array<ProductionOperationRelationshipDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/production-orders/{uuid}/relationships',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @returns ProductionOperationDto OK
     * @throws ApiError
     */
    public static getProductionOperations(
        uuid: string,
    ): CancelablePromise<Array<ProductionOperationDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/production-orders/{uuid}/operations',
            path: {
                'uuid': uuid,
            },
        });
    }
    /**
     * @param uuid
     * @returns ProductionExecutionDto OK
     * @throws ApiError
     */
    public static getProductionExecutions(
        uuid: string,
    ): CancelablePromise<Array<ProductionExecutionDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/production-orders/{uuid}/executions',
            path: {
                'uuid': uuid,
            },
        });
    }
}
